/**
 * Thomas Ford Christmas Theme - Main JavaScript
 */

(function() {
  'use strict';

  // ========================================
  // Mobile Menu Toggle
  // ========================================
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  
  function openMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.add('active');
      mobileMenuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  
  function closeMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.remove('active');
      mobileMenuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      openMobileMenu();
    });
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function() {
      closeMobileMenu();
    });
  }
  
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function() {
      closeMobileMenu();
    });
  }
  
  // Close menu when clicking a link
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
  mobileNavLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      closeMobileMenu();
    });
  });
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  // ========================================
  // Search Drawer
  // ========================================
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchClose = document.querySelector('[data-search-close]');
  
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function() {
      searchDrawer.classList.add('active');
      const searchInput = searchDrawer.querySelector('.search-input');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', function() {
        searchDrawer.classList.remove('active');
      });
    }

    // Close search drawer on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchDrawer.classList.contains('active')) {
        searchDrawer.classList.remove('active');
      }
    });

    // Close search drawer when clicking outside
    searchDrawer.addEventListener('click', function(e) {
      if (e.target === searchDrawer) {
        searchDrawer.classList.remove('active');
      }
    });
  }

  // ========================================
  // Product Image Gallery
  // ========================================
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const mainImage = document.querySelector('[data-main-image]');
  
  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function() {
        const imageUrl = this.getAttribute('data-image');
        mainImage.src = imageUrl;
        
        // Update active state
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // ========================================
  // Quantity Selectors
  // ========================================
  const quantityMinusButtons = document.querySelectorAll('[data-quantity-minus]');
  const quantityPlusButtons = document.querySelectorAll('[data-quantity-plus]');
  
  quantityMinusButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const input = this.parentElement.querySelector('[data-quantity-input]');
      const currentValue = parseInt(input.value) || 1;
      if (currentValue > 1) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event('change'));
      }
    });
  });
  
  quantityPlusButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const input = this.parentElement.querySelector('[data-quantity-input]');
      const currentValue = parseInt(input.value) || 1;
      input.value = currentValue + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // ========================================
  // Cart Functionality
  // ========================================
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  
  if (cartToggle) {
    cartToggle.addEventListener('click', function() {
      window.location.href = '/cart';
    });
  }

  // Update cart count
  function updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach(function(element) {
      element.textContent = count;
      if (count > 0) {
        element.style.display = 'flex';
      } else {
        element.style.display = 'none';
      }
    });
  }

  // Initialize cart count display on page load
  function initCartCount() {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach(function(element) {
      const count = parseInt(element.textContent) || 0;
      if (count > 0) {
        element.style.display = 'flex';
      } else {
        element.style.display = 'none';
      }
    });
  }
  
  initCartCount();

  // Quick Add to Cart
  const quickAddButtons = document.querySelectorAll('.product-card-quick-add');
  
  quickAddButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');
      const originalText = this.textContent;
      
      // Show loading state
      this.textContent = 'Adding...';
      this.disabled = true;
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Success feedback
        this.textContent = 'Added! ✓';
        this.style.background = '#065F46';
        
        // Update cart count
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        
        // Reset button after delay
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
          this.style.background = '';
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.textContent = 'Error';
        this.style.background = '#DC2626';
        
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
          this.style.background = '';
        }, 2000);
      });
    });
  });

  // ========================================
  // Cart Page - Update Quantities
  // ========================================
  const cartQuantityInputs = document.querySelectorAll('.cart-item [data-quantity-input]');
  
  cartQuantityInputs.forEach(function(input) {
    let timeout;
    input.addEventListener('change', function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const line = this.getAttribute('data-line');
        const quantity = parseInt(this.value) || 0;
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: line,
            quantity: quantity
          })
        })
        .then(response => response.json())
        .then(cart => {
          // Reload page to update cart
          window.location.reload();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        });
      }, 500);
    });
  });

  // ========================================
  // Collection Sort
  // ========================================
  const sortSelect = document.querySelector('[data-sort-by]');
  
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const sortValue = this.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      window.location.href = url.toString();
    });

    // Set current sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }

  // ========================================
  // Sticky Header
  // ========================================
  const header = document.querySelector('[data-header]');
  let lastScrollTop = 0;
  
  if (header) {
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 100) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
      } else {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      }
      
      lastScrollTop = scrollTop;
    });
  }

  // ========================================
  // Smooth Scroll for Anchor Links
  // ========================================
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // ========================================
  // Form Validation
  // ========================================
  const forms = document.querySelectorAll('form[data-validate]');
  
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const requiredFields = form.querySelectorAll('[required]');
      let isValid = true;
      
      requiredFields.forEach(function(field) {
        if (!field.value.trim()) {
          isValid = false;
          field.style.borderColor = '#DC2626';
          
          // Reset border color on input
          field.addEventListener('input', function() {
            this.style.borderColor = '';
          }, { once: true });
        }
      });
      
      if (!isValid) {
        e.preventDefault();
        alert('Please fill in all required fields.');
      }
    });
  });

  // ========================================
  // Product Variant Selection
  // ========================================
  const productForm = document.querySelector('[data-product-form]');
  
  if (productForm) {
    const variantSelects = productForm.querySelectorAll('[data-option-select]');
    const variantIdInput = productForm.querySelector('[data-variant-id-input]');
    const addToCartBtn = productForm.querySelector('[data-add-to-cart-btn]');
    const addToCartText = productForm.querySelector('[data-add-to-cart-text]');
    const priceElement = document.querySelector('[data-product-price]');
    const formError = productForm.querySelector('[data-form-error]');
    
    // Get product data
    let productData = null;
    const productJsonElement = document.querySelector('[data-product-json]');
    if (productJsonElement) {
      try {
        productData = JSON.parse(productJsonElement.textContent);
      } catch (e) {
        console.error('Error parsing product JSON:', e);
      }
    }

    if (variantSelects.length > 0 && productData) {
      // Store all original options for each select
      const selectOptionsCache = new Map();
      variantSelects.forEach(function(select) {
        const position = parseInt(select.getAttribute('data-option-position'));
        const options = Array.from(select.options).map(opt => ({
          value: opt.value,
          text: opt.text
        }));
        selectOptionsCache.set(position, options);
      });

      // Separate primary and secondary selects
      const primarySelects = Array.from(variantSelects).filter(s => s.getAttribute('data-option-type') === 'primary');
      const secondarySelects = Array.from(variantSelects).filter(s => s.getAttribute('data-option-type') === 'secondary');
      const secondaryContainers = document.querySelectorAll('[data-secondary-option]');

      variantSelects.forEach(function(select) {
        select.addEventListener('change', function() {
          updateAvailableOptions();
          updateVariant();
        });
      });

      function updateAvailableOptions() {
        // Get currently selected options by position
        const selectedOptionsByPosition = {};
        
        variantSelects.forEach(function(select) {
          const position = parseInt(select.getAttribute('data-option-position'));
          selectedOptionsByPosition[position] = select.value;
        });

        console.log('=== Updating Available Options ===');
        console.log('Currently selected:', selectedOptionsByPosition);

        // Check if primary options are selected
        let allPrimarySelected = true;
        primarySelects.forEach(function(select) {
          if (!select.value || select.value === '') {
            allPrimarySelected = false;
          }
        });

        // Show/hide secondary options based on primary selection
        secondaryContainers.forEach(function(container) {
          if (allPrimarySelected) {
            container.style.display = 'block';
          } else {
            container.style.display = 'none';
          }
        });

        // Filter secondary options based on primary selections
        secondarySelects.forEach(function(select) {
          const currentPosition = parseInt(select.getAttribute('data-option-position'));
          const allOptionsForPosition = selectOptionsCache.get(currentPosition);
          const currentValue = select.value;

          // Find which option values are available given primary selections
          const availableValues = new Set();

          productData.variants.forEach(function(variant) {
            // Check if this variant matches all primary selections
            let matchesPrimarySelections = true;
            
            primarySelects.forEach(function(primarySelect) {
              const primaryPosition = parseInt(primarySelect.getAttribute('data-option-position'));
              const selectedValue = selectedOptionsByPosition[primaryPosition];
              if (selectedValue) {
                const variantValue = variant.options[primaryPosition - 1];
                if (variantValue !== selectedValue) {
                  matchesPrimarySelections = false;
                }
              }
            });

            // If it matches primary selections, add this variant's secondary option value
            if (matchesPrimarySelections) {
              availableValues.add(variant.options[currentPosition - 1]);
            }
          });

          console.log('Position', currentPosition, 'available values:', Array.from(availableValues));

          // Rebuild the select options, only showing available ones
          select.innerHTML = '';
          
          // Add placeholder option
          const placeholderOption = document.createElement('option');
          placeholderOption.value = '';
          placeholderOption.text = 'Select ' + select.previousElementSibling.textContent;
          select.appendChild(placeholderOption);
          
          let foundCurrentValue = false;
          
          allOptionsForPosition.forEach(function(optionData) {
            // Skip the placeholder option from cache
            if (optionData.value === '') return;
            
            if (availableValues.has(optionData.value)) {
              const option = document.createElement('option');
              option.value = optionData.value;
              option.text = optionData.text;
              if (optionData.value === currentValue) {
                option.selected = true;
                foundCurrentValue = true;
              }
              select.appendChild(option);
            }
          });

          // If current value is no longer available, reset to placeholder
          if (!foundCurrentValue) {
            select.selectedIndex = 0;
            console.log('Reset to placeholder');
          }
        });
      }

      function updateVariant() {
        // Get selected options in the correct position order
        const selectedOptionsByPosition = {};
        variantSelects.forEach(function(select) {
          const position = parseInt(select.getAttribute('data-option-position'));
          selectedOptionsByPosition[position] = select.value;
        });

        // Build options array in position order (1, 2, 3, etc.)
        const selectedOptions = [];
        for (let i = 1; i <= Object.keys(selectedOptionsByPosition).length; i++) {
          selectedOptions.push(selectedOptionsByPosition[i]);
        }

        console.log('Selected options by position:', selectedOptionsByPosition);
        console.log('Selected options array:', selectedOptions);

        // Check if all options are selected
        let allSelected = true;
        selectedOptions.forEach(function(opt) {
          if (!opt || opt === '') {
            allSelected = false;
          }
        });

        if (!allSelected) {
          console.log('Not all options selected yet');
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
          }
          if (addToCartText) {
            addToCartText.textContent = 'Select Options';
          }
          return;
        }

        // Find matching variant
        const matchedVariant = productData.variants.find(function(variant) {
          const match = variant.options.every(function(option, index) {
            return option === selectedOptions[index];
          });
          return match;
        });

        console.log('Matched variant:', matchedVariant);

        if (matchedVariant) {
          // Update hidden variant ID input
          if (variantIdInput) {
            variantIdInput.value = matchedVariant.id;
            console.log('Updated variant ID to:', matchedVariant.id);
          }

          // Update button state
          if (addToCartBtn && addToCartText) {
            if (matchedVariant.available) {
              addToCartBtn.disabled = false;
              addToCartText.textContent = addToCartText.getAttribute('data-available-text') || 'Add to Cart';
            } else {
              addToCartBtn.disabled = true;
              addToCartText.textContent = 'Sold Out';
            }
          }

          // Update price
          if (priceElement && matchedVariant.price) {
            const price = formatMoney(matchedVariant.price);
            const comparePrice = matchedVariant.compare_at_price ? formatMoney(matchedVariant.compare_at_price) : null;
            
            console.log('Updating price to:', price, 'Compare price:', comparePrice);
            
            if (comparePrice && matchedVariant.compare_at_price > matchedVariant.price) {
              priceElement.innerHTML = `
                <span class="price-compare">${comparePrice}</span>
                <span class="price-sale">${price}</span>
                <span class="price-badge">SALE 🎄</span>
              `;
            } else {
              priceElement.innerHTML = `<span class="price">${price}</span>`;
            }
          } else {
            console.error('Price element not found or variant has no price');
          }
        } else {
          console.error('No matching variant found for options:', selectedOptions);
          // Disable add to cart if no variant matches
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
          }
          if (addToCartText) {
            addToCartText.textContent = 'Unavailable';
          }
        }
      }
      
      // Call on page load to set up initial state
      updateAvailableOptions();
      updateVariant();
    }

    // Handle form submission
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      if (formError) {
        formError.style.display = 'none';
      }

      const formData = new FormData(productForm);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;

      if (!variantId) {
        if (formError) {
          formError.textContent = 'Please select a variant';
          formError.style.display = 'block';
        }
        return;
      }

      // Show loading state
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        const originalText = addToCartText ? addToCartText.textContent : 'Add to Cart';
        if (addToCartText) {
          addToCartText.textContent = 'Adding...';
        }

        // Add to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          // Success feedback
          if (addToCartText) {
            addToCartText.textContent = 'Added! ✓';
          }
          if (addToCartBtn) {
            addToCartBtn.style.background = '#065F46';
          }
          
          // Update cart count
          return fetch('/cart.js');
        })
        .then(response => response.json())
        .then(cart => {
          updateCartCount(cart.item_count);
          
          // Reset button after delay
          setTimeout(() => {
            if (addToCartText) {
              addToCartText.textContent = originalText;
            }
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.style.background = '';
            }
            // Reset quantity to 1
            const quantityInput = productForm.querySelector('[data-quantity-input]');
            if (quantityInput) {
              quantityInput.value = 1;
            }
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          if (formError) {
            formError.textContent = error.description || error.message || 'Error adding to cart';
            formError.style.display = 'block';
          }
          if (addToCartText) {
            addToCartText.textContent = 'Error';
          }
          if (addToCartBtn) {
            addToCartBtn.style.background = '#DC2626';
          }
          
          setTimeout(() => {
            if (addToCartText) {
              addToCartText.textContent = originalText;
            }
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.style.background = '';
            }
          }, 2000);
        });
      }
    });
  }

  // Money formatting helper
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '£{{amount}}';
    
    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  // ========================================
  // Lazy Loading Images
  // ========================================
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });

    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(function(img) {
      imageObserver.observe(img);
    });
  }

  // ========================================
  // Christmas Special Effects
  // ========================================
  
  // Add jingle sound on button clicks (optional - commented out by default)
  /*
  const buttons = document.querySelectorAll('.btn-primary, .btn-secondary');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      // Play a subtle jingle sound
      // const audio = new Audio('/path/to/jingle.mp3');
      // audio.volume = 0.2;
      // audio.play();
    });
  });
  */

  // Christmas countdown (if needed)
  function updateChristmasCountdown() {
    const christmas = new Date(new Date().getFullYear(), 11, 25);
    const now = new Date();
    const diff = christmas - now;
    
    if (diff > 0) {
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const countdownElement = document.querySelector('[data-christmas-countdown]');
      if (countdownElement) {
        countdownElement.textContent = `${days} days until Christmas!`;
      }
    }
  }
  
  updateChristmasCountdown();

  // ========================================
  // Accessibility Enhancements
  // ========================================
  
  // Trap focus in mobile menu when open
  if (mobileMenu) {
    const focusableElements = mobileMenu.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    mobileMenu.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });
  }

  // Announce cart updates to screen readers
  function announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    document.body.appendChild(announcement);
    
    setTimeout(() => {
      document.body.removeChild(announcement);
    }, 1000);
  }

  // ========================================
  // Performance Optimization
  // ========================================
  
  // Debounce function for scroll and resize events
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // ========================================
  // Product Image Zoom
  // ========================================
  const zoomContainers = document.querySelectorAll('[data-zoom-container]');
  
  zoomContainers.forEach(function(container) {
    const zoomBtn = container.querySelector('[data-zoom-toggle]');
    const mainImage = container.querySelector('[data-main-image]');
    
    if (zoomBtn && mainImage) {
      zoomBtn.addEventListener('click', function() {
        const zoomUrl = mainImage.getAttribute('data-zoom-image') || mainImage.src;
        
        // Create zoom modal
        const modal = document.createElement('div');
        modal.className = 'zoom-modal';
        modal.innerHTML = `
          <div class="zoom-modal-content">
            <button class="zoom-modal-close" aria-label="Close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <img src="${zoomUrl}" alt="Zoomed product image">
          </div>
        `;
        
        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';
        
        // Close on click
        modal.addEventListener('click', function(e) {
          if (e.target === modal || e.target.closest('.zoom-modal-close')) {
            document.body.removeChild(modal);
            document.body.style.overflow = '';
          }
        });
        
        // Close on escape
        document.addEventListener('keydown', function escapeHandler(e) {
          if (e.key === 'Escape') {
            if (document.body.contains(modal)) {
              document.body.removeChild(modal);
              document.body.style.overflow = '';
            }
            document.removeEventListener('keydown', escapeHandler);
          }
        });
      });
    }
  });

  // ========================================
  // Wishlist Functionality
  // ========================================
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  
  function updateWishlistUI() {
    const wishlistBtns = document.querySelectorAll('[data-wishlist-btn]');
    wishlistBtns.forEach(function(btn) {
      const productId = btn.getAttribute('data-product-id');
      if (wishlist.includes(productId)) {
        btn.classList.add('active');
        btn.innerHTML = '❤️';
      } else {
        btn.classList.remove('active');
        btn.innerHTML = '🤍';
      }
    });
  }
  
  document.addEventListener('click', function(e) {
    const wishlistBtn = e.target.closest('[data-wishlist-btn]');
    if (wishlistBtn) {
      e.preventDefault();
      const productId = wishlistBtn.getAttribute('data-product-id');
      
      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter(id => id !== productId);
      } else {
        wishlist.push(productId);
      }
      
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateWishlistUI();
      
      // Show feedback
      const feedback = document.createElement('div');
      feedback.className = 'wishlist-feedback';
      feedback.textContent = wishlist.includes(productId) ? 'Added to wishlist!' : 'Removed from wishlist';
      document.body.appendChild(feedback);
      
      setTimeout(() => {
        feedback.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        feedback.classList.remove('show');
        setTimeout(() => document.body.removeChild(feedback), 300);
      }, 2000);
    }
  });
  
  updateWishlistUI();

  // ========================================
  // Better Loading States
  // ========================================
  const allForms = document.querySelectorAll('form');
  allForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn.disabled) {
        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.classList.add('loading');
        
        // Add spinner
        submitBtn.innerHTML = `
          <span class="btn-spinner"></span>
          <span>${originalText}</span>
        `;
      }
    });
  });

  // ========================================
  // Initialize on DOM Ready
  // ========================================
  console.log('🎄 Thomas Ford Christmas Theme Loaded! 🎄');
  
  // Add loaded class to body
  document.body.classList.add('theme-loaded');

})();

